module.exports = __webpack_public_path__ + "1792771649312/fonts/Comfortaa-Regular.c2488bf.ttf";